import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { catchError, map } from 'rxjs/operators';
import { TaxRateTable } from '../models/TaxRateTable';
import { NGXLogger } from 'ngx-logger';

@Injectable({ providedIn: 'root' })
export class TaxManagementService {

    isSaveNeeded: boolean = false;

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService,
        private log: NGXLogger
    ) { }

    getTaxRateTableByMerchantId(merchantId): Observable<TaxRateTable> {
        return this.http.get<TaxRateTable>(`${this.configService.config.urlAPI.urlTaxManagement}/byMerchant/${merchantId}`).pipe(catchError(err => {
            if (err.status == "404") {
                this.log.error(err);
            } else {
                this.notifService.notifyErrorWithDetailFromApi('ERROR_TAXRATE_TABLE_API', err);
            }
            return of(null);
        }));
    }

    deleteTaxRateTable(id): Observable<TaxRateTable> {
        return this.http.delete<TaxRateTable>(`${this.configService.config.urlAPI.urlTaxManagement}/${id}`).pipe(catchError(err => {
            this.log.error(err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TAXRATE_TABLE_API', err);
            return of(null);
        }));
    }

    updateTaxRateTable(mappingTable: TaxRateTable): Observable<TaxRateTable> {
        return this.http.put<TaxRateTable>(this.configService.config.urlAPI.urlTaxManagement, mappingTable).pipe(catchError(err => {
            this.log.error(err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TAXRATE_TABLE_API', err);
            return of(null);
        }));
    }

    createTaxRateTable(mappingTable: TaxRateTable): Observable<TaxRateTable> {
        return this.http.post<TaxRateTable>(this.configService.config.urlAPI.urlTaxManagement, mappingTable).pipe(catchError(err => {
            this.log.error(err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TAXRATE_TABLE_API', err);
            return of(null);
        }));
    }

}
